<section class="min-h-screen flex flex-col">
  <app-nav-bar />

  <main class="flex-1 p-4">
    <router-outlet />
  </main>

  <app-footer />
</section>
